import { getAccessToken } from "@devforce/trailhead-client-auth";
import * as env from "@devforce/trailhead-client-env";
import { postJSON } from "@devforce/trailhead-client-fetch";
import { getLocale } from "@devforce/trailhead-client-locale";
import { Logger } from "@devforce/trailhead-client-logger";
export const PACKAGE_NAME = "@devforce/trailhead-client-logger";
export const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
function getViewContext(event) {
    let viewContext = null;
    if (state.viewContext || event.viewContext) {
        // @ts-ignore
        viewContext = {
            ...state.viewContext,
            ...event.viewContext,
        };
    }
    return viewContext;
}
async function sendEvent(key, event) {
    if (!state.enabled) {
        logger.warn("Tracking is not currently enabled");
        return;
    }
    let query = `
  mutation TrackUserActivityMutation($input: TrackEventsInput!) {
    trackEvents(input: $input) {
      completed
    }
  }
  `;
    let variables = {
        input: {
            events: [{ [key]: event }],
        },
    };
    let accessToken = await getAccessToken();
    let headers = {};
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }
    if (state.visitorId) {
        headers["X_TRAILHEAD_DEVICE_ID"] = state.visitorId;
    }
    await postJSON(env.get("EXPERIENCE_API_HOST"), { query, variables }, { headers });
}
export function setTrackingEnabled(value) {
    state.enabled = value;
}
export function setVisitorId(id) {
    state.visitorId = id;
}
export function setViewContext(viewContext) {
    state.viewContext = viewContext;
}
export function trackUxEvent(event) {
    // @ts-ignore
    let eventMerged = {
        ...event,
        eventAt: new Date().toISOString(),
        viewContext: getViewContext(event),
    };
    sendEvent("uxEvent", eventMerged).catch((e) => logger.error(e));
}
export function trackViewEvent(event) {
    // @ts-ignore
    let eventMerged = {
        ...event,
        lang: getLocale(),
        timestamp: new Date().toISOString(),
        viewContext: getViewContext(event),
    };
    sendEvent("viewEvent", eventMerged).catch((e) => logger.error(e));
}
let state = {
    enabled: true,
    viewContext: null,
};
export function initializeState(currentState, existingState) {
    return existingState !== null && existingState !== void 0 ? existingState : currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
